import {
	FormControlLabel,
	Grid,
	IconButton,
	Switch,
	TextField,
	Typography,
} from "@mui/material";
import { HighlightOff } from "@mui/icons-material";
import { FormikErrors, FormikTouched } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { WebChatEntryPointCustomField } from "src/types/textEntryPoints";

interface WebChatEntryPointCustomFieldProps {
	customField: WebChatEntryPointCustomField;
	index: number;
	errors: FormikErrors<WebChatEntryPointCustomField>;
	touched: FormikTouched<WebChatEntryPointCustomField>;
	handleBlur: (event: React.FocusEvent) => void;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	handleDelete: () => void;
}

const WebChatCustomFieldInput: FC<WebChatEntryPointCustomFieldProps> = (
	props
) => {
	const {
		customField,
		index,
		errors,
		touched,
		handleBlur,
		handleChange,
		handleDelete,
	} = props;
	const { t } =
		typeof jest !== "undefined" ? { t: (s) => s } : useTranslation();

	return (
		<Grid
			item
			container
			spacing={1}
			direction="row"
			data-testid={`customFieldItem_${index}`}
		>
			<Grid item xs={12} sm={6} md={6} lg={6} xl={3}>
				<TextField
					label={t("MessagingQueue.CustomFieldName")}
					size="small"
					color="info"
					key={`custom-filed-name-txt-${index}`}
					onChange={handleChange}
					onBlur={handleBlur}
					name={`customFields.${index}.name`}
					value={customField.name}
					error={
						!!touched && touched.name && !!errors && !!errors.name
					}
					helperText={
						!!touched && !!touched.name && errors
							? errors.name
							: null
					}
					data-testid="customField"
					fullWidth
					sx={{ marginTop: "20px" }}
				/>
			</Grid>
			<Grid
				item
				container
				xs={12}
				sm={12}
				md={12}
				lg={12}
				xl={6}
				sx={{
					marginBottom:
						!!touched && !!touched.name && !!errors && !!errors.name
							? 3
							: 0,
				}}
			>
				<Grid
					item
					xl={12}
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
					}}
				>
					<FormControlLabel
						control={
							<Switch
								checked={customField.isRequired}
								name={`customFields.${index}.isRequired`}
								onChange={handleChange}
								onBlur={handleBlur}
								data-testid="customFieldsRequired"
								sx={{ marginTop: "20px" }}
							/>
						}
						label={
							<Typography
								color="textPrimary"
								noWrap
								sx={{ marginTop: "20px" }}
							>
								{t("MessagingQueue.CustomfieldIsRequired")}
							</Typography>
						}
						labelPlacement="start"
					/>
					<IconButton
						onClick={handleDelete}
						data-testid="setIsDeleteUIActiveToTrue"
						sx={{ marginTop: "20px" }}
					>
						<HighlightOff />
					</IconButton>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default WebChatCustomFieldInput;
